'use es6';

import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UISideNav from 'UIComponents/nav/UISideNav';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import GoodSubTypeGroups from '../constants/GoodSubTypeGroups';
import GoodSubTypes from '../constants/GoodSubTypes';
import { getCategoryOptionText } from '../utils/langUtils';
import { getCategoryMenuOptions } from '../utils/sidebarUtils';
export default createReactClass({
  displayName: "CategoryDropdown",
  mixins: [ComponentWithPartials],
  propTypes: {
    categoryFilter: PropTypes.string.isRequired,
    onGoodFilterChange: PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      isTemplateMenuOpen: false
    };
  },
  getGoodFilterChangeHandlerForCategory: function getGoodFilterChangeHandlerForCategory(category) {
    var params = {};
    params[GoodFiltersAndPage.SUB_TYPE] = category;
    return this.props.onGoodFilterChange(params);
  },
  toggleMenuDisplay: function toggleMenuDisplay() {
    this.setState({
      isTemplateMenuOpen: !this.state.isTemplateMenuOpen
    });
  },
  handleParentClick: function handleParentClick(item, e) {
    var isTemplateMenuOpen = this.state.isTemplateMenuOpen;

    if (item === GoodSubTypeGroups.TEMPLATES) {
      if (e.target.innerText === 'down') {
        this.toggleMenuDisplay();
      } else {
        this.getGoodFilterChangeHandlerForCategory(item);

        if (!isTemplateMenuOpen) {
          this.toggleMenuDisplay();
        }
      }
    } else {
      this.getGoodFilterChangeHandlerForCategory(item);
    }
  },
  renderItem: function renderItem(item, chevron) {
    var isTheme = item === GoodSubTypes.CMS_THEME;
    var computedClassName = "integrate-category-" + item + (isTheme ? " align-baseline" : "");
    var title = getCategoryOptionText(item);

    if (isTheme) {
      title = React.createElement(UIMediaObject, {
        align: "center",
        itemRight: React.createElement(UIBadge, {
          use: "new"
        }, React.createElement(FormattedMessage, {
          message: "MarketplaceUI.directory.sidebar.newBadge"
        }))
      }, title);
    }

    return React.createElement(UISideNavItem, {
      className: computedClassName,
      value: item,
      key: item,
      title: title,
      onClick: this.partial(this.getGoodFilterChangeHandlerForCategory, item),
      iconRight: chevron ? 'right' : null
    });
  },
  renderOption: function renderOption(_ref) {
    var _this = this;

    var item = _ref.item,
        subMenu = _ref.subMenu,
        chevron = _ref.chevron;
    var isTemplateMenuOpen = this.state.isTemplateMenuOpen;

    if (subMenu) {
      return React.createElement(UISideNavItem, {
        defaultOpen: true,
        key: item,
        value: item,
        title: getCategoryOptionText(item),
        open: isTemplateMenuOpen,
        onClick: this.partial(this.handleParentClick, item),
        iconRight: chevron ? 'right' : null
      }, subMenu.map(function (option) {
        return _this.renderOption(option);
      }));
    }

    return this.renderItem(item, chevron);
  },
  render: function render() {
    var _this2 = this;

    var categoryFilter = this.props.categoryFilter;
    return React.createElement("div", {
      className: "dropdown-container integrate-category-menu"
    }, React.createElement(UISideNav, {
      value: categoryFilter,
      className: "m-bottom-0"
    }, getCategoryMenuOptions(categoryFilter).map(function (option) {
      return _this2.renderOption(option);
    })));
  }
});